import React, { useContext, useState } from 'react'
import ApplicationContext from '../../../context/ApplicationContext'
import moment from 'moment'
import PropTypes from 'prop-types'
import styles from './LocationHour.module.scss'

const LocationHour = ({ hour }) => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const { daysOfTheWeek } = localizations

    return (
        <div className={styles.content}>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.mon}</span>
                <span className={styles.hours}>
                    {hour.mondayStart !== null
                        ? `${moment(hour.mondayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.mondayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.tue}</span>
                <span className={styles.hours}>
                    {hour.tuesdayStart !== null
                        ? `${moment(hour.tuesdayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.tuesdayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.wed}</span>
                <span className={styles.hours}>
                    {hour.wednesdayStart !== null
                        ? `${moment(hour.wednesdayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.wednesdayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.thu}</span>
                <span className={styles.hours}>
                    {hour.thursdayStart !== null
                        ? `${moment(hour.thursdayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.thursdayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.fri}</span>
                <span className={styles.hours}>
                    {hour.fridayStart !== null
                        ? `${moment(hour.fridayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.fridayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.sat}</span>
                <span className={styles.hours}>
                    {hour.saturdayStart !== null
                        ? `${moment(hour.saturdayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.saturdayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
            <p className={styles.time}>
                <span className={styles.day}>{daysOfTheWeek.sun}</span>
                <span className={styles.hours}>
                    {hour.sundayStart !== null
                        ? `${moment(hour.sundayStart, 'h:mm a').format('h:mm a')} - ${moment(hour.sundayEnd, 'h:mm a').format('h:mm a')}`
                        : localizations.closed}
                </span>
            </p>
        </div>
    )
}

LocationHour.propTypes = {
    hour: PropTypes.object,
    handleGoBack: PropTypes.func,
    handleClose: PropTypes.func,
}
export default LocationHour
